import React from 'react';
import '../template-file-css/document-file-template.css';


export const LBS_SafetyPlan = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='LBS_SafetyPlan' className='file-pdf-document'>
            <div className='file-template'>

    <table>
        <tr>
            <td className='w-250'>
                <span className='eleHeader'>Consumer's Name:</span>
                <input type='text' id="txtConsumersName" name="txtConsumersName" className='add-only' />
            </td>
            <td className='w-250'>
                <span className='eleHeader'>Date:</span>
                <input type='date' id="txtDate" name="txtDate" className='add-only' />
            </td>
            <td className='w-250'>
                <span className='eleHeader'>Safety Factor:</span>
                <input type='text' id="txtSafetyFactor1" name="txtSafetyFactor1" className='add-only' />
            </td>
        </tr>
    </table>
    <table>
            <tr>
                <td className='w-750'>
                    <span className='eleHeader'>Steps</span>
                    <span className='small'>Specify who will do what, where, when and in what time frame.</span>
                </td>
            </tr>
            <tr>
                <td className='w-20'>
                    1)
                </td>
                <td className='w-730'>
                    <textarea id="txtSteps1_1" name="txtSteps1_1" className='add-only'></textarea>
                </td>
            </tr>
            <tr>
                <td className='w-20'>
                    2)
                </td>
                <td className='w-730'>
                    <textarea id="txtSteps1_2" name="txtSteps1_2" className='add-only' ></textarea>
                </td>
            </tr>
            <tr>
                <td className='w-20'>
                    3)
                </td>
                <td className='w-730'>
                    <textarea id="txtSteps1_3" name="txtSteps1_3" className='add-only' ></textarea>
                </td>
            </tr>
        </table>
    <p className='w-750'>
        <span className='eleHeader'>Triggers</span>
        <span className='small'>Identify the consumer's triggers that contribute to this behavior
            being a safety concern.</span>
        <textarea id="txtProgress" name="txtProgress" className='add-only' ></textarea></p>
    <p className='w-750'>
        <span className='eleHeader'>Coping Skills</span>
        <span className='small'>Identify the consumer's current coping skills related to this safety
            factor.</span>
        <textarea id="TextBox1" name="TextBox1" className='add-only' ></textarea></p>
    <p>
        <span className='eleHeader'>Safety Factor:</span>
        <input type='text' id="txtSafetyFactor2" name="txtSafetyFactor2" className='add-only' /></p>
    <table>
        <tr>
            <td className='w-750'>
                <span className='eleHeader'>Steps</span>
                <span className='small'>Specify who will do what, where, when and in what time frame.</span>
            </td>
        </tr>
        <tr>
            <td className='w-20'>
                1)
            </td>
            <td className='w-730'>
                <textarea id="txtSteps2_1" name="txtSteps2_1" className='add-only' ></textarea>
            </td>
        </tr>
        <tr>
            <td className='w-20'>
                2)
            </td>
            <td className='w-730'>
                <textarea id="txtSteps2_2" name="txtSteps2_2" className='add-only' ></textarea>
            </td>
        </tr>
        <tr>
            <td className='w-20'>
                3)
            </td>
            <td className='w-730'>
                <textarea id="txtSteps2_3" name="txtSteps2_3" className='add-only' ></textarea>
            </td>
        </tr>
    </table>
    <p className='w-750'>
        <span className='eleHeader'>Triggers</span>
        <span className='small'>Identify the consumer's triggers that contribute to this behavior
            being a safety concern.</span>
        <textarea id="TextBox6" name="TextBox6" className='add-only' ></textarea></p>
    <p className='w-750'>
        <span className='eleHeader'>Coping Skills</span>
        <span className='small'>Identify the consumer's current coping skills related to this safety
            factor.</span>
        <textarea id="TextBox7" name="TextBox7" className='add-only' ></textarea></p>
    <p>
        <span className='eleHeader'>Safety Factor:</span>
        <input type='text' id="txtSafetyFactor3" name="txtSafetyFactor3" className='add-only' /></p>
    <table>
        <tr>
            <td className='w-750'>
                <span className='eleHeader'>Steps</span>
                <span className='small'>Specify who will do what, where, when and in what time frame.</span>
            </td>
        </tr>
        <tr>
            <td className='w-20'>
                1)
            </td>
            <td className='w-730'>
                <textarea id="txtSteps3_1" name="txtSteps3_1" className='add-only' ></textarea>
            </td>
        </tr>
        <tr>
            <td className='w-20'>
                2)
            </td>
            <td className='w-730'>
                <textarea id="txtSteps3_2" name="txtSteps3_2" className='add-only' ></textarea>
            </td>
        </tr>
        <tr>
            <td className='w-20'>
                3)
            </td>
            <td className='w-730'>
                <textarea id="txtSteps3_3" name="txtSteps3_3" className='add-only' ></textarea>
            </td>
        </tr>
    </table>
    <p className='w-750'>
        <span className='eleHeader'>Triggers</span>
        <span className='small'>Identify the consumer's triggers that contribute to this behavior
            being a safety concern.</span>
        <textarea id="TextBox12" name="TextBox12" className='add-only' ></textarea></p>
    <p className='w-750'>
        <span className='eleHeader'>Coping Skills</span>
        <span className='small'>Identify the consumer's current coping skills related to this safety
            factor.</span>
        <textarea id="TextBox13" name="TextBox13" className='add-only' ></textarea></p>
    <table>
        <tr>
          <td className='signature w-375'>&nbsp; </td>
          <td className='signature w-375'>&nbsp; </td>
        </tr>
        <tr>
            <td className='small w-375'>&nbsp;</td>
            <td className='small w-375'>Date</td>
        </tr>
        <tr>
          <td className='signature w-375'>&nbsp; </td>
          <td className='signature w-375'>&nbsp; </td>
        </tr>
        <tr>
            <td className='small w-375'>&nbsp;</td>
            <td className='small w-375'>Date</td>
        </tr>
    </table>
    </div>
</form>
    )
}
